<template>
  <v-container fill-height wrap grid-list-lg>
    <v-layout align-center justify-center pa-5 wrap>
      <v-flex xs12 sm8 lg6>
        <v-card height="72vh" style="overflow-y: hidden">

        <v-card-text>
        <v-simple-table fixed-header height="70vh">
          <thead>
            <tr>
            <th class="text-center" colspan="2">
            <v-icon class="mx-auto text-center" large>edit</v-icon>
            </th>
            </tr>
          </thead>
          <tbody>
            <tr
             v-for="item in items"
             :key="item.id"
             @click="itemClicked(item)"
             style="cursor: pointer">
              <td>
                <p class="title mb-0 mt-2">{{ item.name.replace(".pdf", "") }}</p>
              </td>
              <td class="text-right"><v-icon>get_app</v-icon></td>
            </tr>
          </tbody>
        </v-simple-table>
        </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { db } from '@/firebase/db';

export default {
  mounted() {
    this.$bind('items', db.collection('exercises').orderBy('name'));
  },
  data: () => ({
    items: [],
  }),
  methods: {
    itemClicked(item) {
      window.open(item.url);
    },
  },
};
</script>
